/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as KioskRouteRouteImport } from './routes/kiosk/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TvRouteRouteImport } from './routes/tv/route'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppModelRegistryRouteRouteImport } from './routes/app/model-registry/route'
import { Route as AppModelTrainingRouteRouteImport } from './routes/app/model-training/route'
import { Route as KioskIndexRouteImport } from './routes/kiosk/index'
import { Route as TvIndexRouteImport } from './routes/tv/index'
import { Route as AppModelRegistryIndexRouteImport } from './routes/app/model-registry/index'
import { Route as AppModelRegistryModelsRouteImport } from './routes/app/model-registry/models'
import { Route as AppModelTrainingIndexRouteImport } from './routes/app/model-training/index'
import { Route as AppModelTrainingDatasetsRouteImport } from './routes/app/model-training/datasets'
import { Route as AppModelRegistryModelsModelIdEvaluationRouteImport } from './routes/app/model-registry/models_.$modelId.evaluation'
import { Route as AppModelRegistryModelsModelIdExperimentRouteImport } from './routes/app/model-registry/models_.$modelId.experiment'
import { Route as AppModelTrainingDatasetsDatasetIdFeaturesRouteImport } from './routes/app/model-training/datasets_.$datasetId.features'
import { Route as AppModelTrainingDatasetsDatasetIdPreprocessingRouteImport } from './routes/app/model-training/datasets_.$datasetId.preprocessing'
import { Route as AppModelTrainingDatasetsDatasetIdPreviewRouteImport } from './routes/app/model-training/datasets_.$datasetId.preview'
import { Route as AppModelTrainingDatasetsDatasetIdTrainRouteImport } from './routes/app/model-training/datasets_.$datasetId.train'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const KioskRouteRoute = KioskRouteRouteImport.update({
  id: '/kiosk',
  path: '/kiosk',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const TvRouteRoute = TvRouteRouteImport.update({
  id: '/tv',
  path: '/tv',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppModelRegistryRouteRoute = AppModelRegistryRouteRouteImport.update({
  id: '/model-registry',
  path: '/model-registry',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppModelTrainingRouteRoute = AppModelTrainingRouteRouteImport.update({
  id: '/model-training',
  path: '/model-training',
  getParentRoute: () => AppRouteRoute,
} as any)
const KioskIndexRoute = KioskIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KioskRouteRoute,
} as any)
const TvIndexRoute = TvIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TvRouteRoute,
} as any)
const AppModelRegistryIndexRoute = AppModelRegistryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppModelRegistryRouteRoute,
} as any)
const AppModelRegistryModelsRoute = AppModelRegistryModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => AppModelRegistryRouteRoute,
} as any)
const AppModelTrainingIndexRoute = AppModelTrainingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppModelTrainingRouteRoute,
} as any)
const AppModelTrainingDatasetsRoute =
  AppModelTrainingDatasetsRouteImport.update({
    id: '/datasets',
    path: '/datasets',
    getParentRoute: () => AppModelTrainingRouteRoute,
  } as any)
const AppModelRegistryModelsModelIdEvaluationRoute =
  AppModelRegistryModelsModelIdEvaluationRouteImport.update({
    id: '/models_/$modelId/evaluation',
    path: '/models/$modelId/evaluation',
    getParentRoute: () => AppModelRegistryRouteRoute,
  } as any)
const AppModelRegistryModelsModelIdExperimentRoute =
  AppModelRegistryModelsModelIdExperimentRouteImport.update({
    id: '/models_/$modelId/experiment',
    path: '/models/$modelId/experiment',
    getParentRoute: () => AppModelRegistryRouteRoute,
  } as any)
const AppModelTrainingDatasetsDatasetIdFeaturesRoute =
  AppModelTrainingDatasetsDatasetIdFeaturesRouteImport.update({
    id: '/datasets_/$datasetId/features',
    path: '/datasets/$datasetId/features',
    getParentRoute: () => AppModelTrainingRouteRoute,
  } as any)
const AppModelTrainingDatasetsDatasetIdPreprocessingRoute =
  AppModelTrainingDatasetsDatasetIdPreprocessingRouteImport.update({
    id: '/datasets_/$datasetId/preprocessing',
    path: '/datasets/$datasetId/preprocessing',
    getParentRoute: () => AppModelTrainingRouteRoute,
  } as any)
const AppModelTrainingDatasetsDatasetIdPreviewRoute =
  AppModelTrainingDatasetsDatasetIdPreviewRouteImport.update({
    id: '/datasets_/$datasetId/preview',
    path: '/datasets/$datasetId/preview',
    getParentRoute: () => AppModelTrainingRouteRoute,
  } as any)
const AppModelTrainingDatasetsDatasetIdTrainRoute =
  AppModelTrainingDatasetsDatasetIdTrainRouteImport.update({
    id: '/datasets_/$datasetId/train',
    path: '/datasets/$datasetId/train',
    getParentRoute: () => AppModelTrainingRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/kiosk': typeof KioskRouteRouteWithChildren
  '/tv': typeof TvRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/model-registry': typeof AppModelRegistryRouteRouteWithChildren
  '/app/model-training': typeof AppModelTrainingRouteRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/kiosk/': typeof KioskIndexRoute
  '/tv/': typeof TvIndexRoute
  '/app/model-registry/models': typeof AppModelRegistryModelsRoute
  '/app/model-training/datasets': typeof AppModelTrainingDatasetsRoute
  '/app/model-registry/': typeof AppModelRegistryIndexRoute
  '/app/model-training/': typeof AppModelTrainingIndexRoute
  '/app/model-registry/models/$modelId/evaluation': typeof AppModelRegistryModelsModelIdEvaluationRoute
  '/app/model-registry/models/$modelId/experiment': typeof AppModelRegistryModelsModelIdExperimentRoute
  '/app/model-training/datasets/$datasetId/features': typeof AppModelTrainingDatasetsDatasetIdFeaturesRoute
  '/app/model-training/datasets/$datasetId/preprocessing': typeof AppModelTrainingDatasetsDatasetIdPreprocessingRoute
  '/app/model-training/datasets/$datasetId/preview': typeof AppModelTrainingDatasetsDatasetIdPreviewRoute
  '/app/model-training/datasets/$datasetId/train': typeof AppModelTrainingDatasetsDatasetIdTrainRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app': typeof AppIndexRoute
  '/kiosk': typeof KioskIndexRoute
  '/tv': typeof TvIndexRoute
  '/app/model-registry/models': typeof AppModelRegistryModelsRoute
  '/app/model-training/datasets': typeof AppModelTrainingDatasetsRoute
  '/app/model-registry': typeof AppModelRegistryIndexRoute
  '/app/model-training': typeof AppModelTrainingIndexRoute
  '/app/model-registry/models/$modelId/evaluation': typeof AppModelRegistryModelsModelIdEvaluationRoute
  '/app/model-registry/models/$modelId/experiment': typeof AppModelRegistryModelsModelIdExperimentRoute
  '/app/model-training/datasets/$datasetId/features': typeof AppModelTrainingDatasetsDatasetIdFeaturesRoute
  '/app/model-training/datasets/$datasetId/preprocessing': typeof AppModelTrainingDatasetsDatasetIdPreprocessingRoute
  '/app/model-training/datasets/$datasetId/preview': typeof AppModelTrainingDatasetsDatasetIdPreviewRoute
  '/app/model-training/datasets/$datasetId/train': typeof AppModelTrainingDatasetsDatasetIdTrainRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/kiosk': typeof KioskRouteRouteWithChildren
  '/tv': typeof TvRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/app/model-registry': typeof AppModelRegistryRouteRouteWithChildren
  '/app/model-training': typeof AppModelTrainingRouteRouteWithChildren
  '/app/': typeof AppIndexRoute
  '/kiosk/': typeof KioskIndexRoute
  '/tv/': typeof TvIndexRoute
  '/app/model-registry/models': typeof AppModelRegistryModelsRoute
  '/app/model-training/datasets': typeof AppModelTrainingDatasetsRoute
  '/app/model-registry/': typeof AppModelRegistryIndexRoute
  '/app/model-training/': typeof AppModelTrainingIndexRoute
  '/app/model-registry/models_/$modelId/evaluation': typeof AppModelRegistryModelsModelIdEvaluationRoute
  '/app/model-registry/models_/$modelId/experiment': typeof AppModelRegistryModelsModelIdExperimentRoute
  '/app/model-training/datasets_/$datasetId/features': typeof AppModelTrainingDatasetsDatasetIdFeaturesRoute
  '/app/model-training/datasets_/$datasetId/preprocessing': typeof AppModelTrainingDatasetsDatasetIdPreprocessingRoute
  '/app/model-training/datasets_/$datasetId/preview': typeof AppModelTrainingDatasetsDatasetIdPreviewRoute
  '/app/model-training/datasets_/$datasetId/train': typeof AppModelTrainingDatasetsDatasetIdTrainRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/kiosk'
    | '/tv'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/app/model-registry'
    | '/app/model-training'
    | '/app/'
    | '/kiosk/'
    | '/tv/'
    | '/app/model-registry/models'
    | '/app/model-training/datasets'
    | '/app/model-registry/'
    | '/app/model-training/'
    | '/app/model-registry/models/$modelId/evaluation'
    | '/app/model-registry/models/$modelId/experiment'
    | '/app/model-training/datasets/$datasetId/features'
    | '/app/model-training/datasets/$datasetId/preprocessing'
    | '/app/model-training/datasets/$datasetId/preview'
    | '/app/model-training/datasets/$datasetId/train'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/app'
    | '/kiosk'
    | '/tv'
    | '/app/model-registry/models'
    | '/app/model-training/datasets'
    | '/app/model-registry'
    | '/app/model-training'
    | '/app/model-registry/models/$modelId/evaluation'
    | '/app/model-registry/models/$modelId/experiment'
    | '/app/model-training/datasets/$datasetId/features'
    | '/app/model-training/datasets/$datasetId/preprocessing'
    | '/app/model-training/datasets/$datasetId/preview'
    | '/app/model-training/datasets/$datasetId/train'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/kiosk'
    | '/tv'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/app/model-registry'
    | '/app/model-training'
    | '/app/'
    | '/kiosk/'
    | '/tv/'
    | '/app/model-registry/models'
    | '/app/model-training/datasets'
    | '/app/model-registry/'
    | '/app/model-training/'
    | '/app/model-registry/models_/$modelId/evaluation'
    | '/app/model-registry/models_/$modelId/experiment'
    | '/app/model-training/datasets_/$datasetId/features'
    | '/app/model-training/datasets_/$datasetId/preprocessing'
    | '/app/model-training/datasets_/$datasetId/preview'
    | '/app/model-training/datasets_/$datasetId/train'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  KioskRouteRoute: typeof KioskRouteRouteWithChildren
  TvRouteRoute: typeof TvRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kiosk': {
      id: '/kiosk'
      path: '/kiosk'
      fullPath: '/kiosk'
      preLoaderRoute: typeof KioskRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tv': {
      id: '/tv'
      path: '/tv'
      fullPath: '/tv'
      preLoaderRoute: typeof TvRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/model-registry': {
      id: '/app/model-registry'
      path: '/model-registry'
      fullPath: '/app/model-registry'
      preLoaderRoute: typeof AppModelRegistryRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/model-training': {
      id: '/app/model-training'
      path: '/model-training'
      fullPath: '/app/model-training'
      preLoaderRoute: typeof AppModelTrainingRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/kiosk/': {
      id: '/kiosk/'
      path: '/'
      fullPath: '/kiosk/'
      preLoaderRoute: typeof KioskIndexRouteImport
      parentRoute: typeof KioskRouteRoute
    }
    '/tv/': {
      id: '/tv/'
      path: '/'
      fullPath: '/tv/'
      preLoaderRoute: typeof TvIndexRouteImport
      parentRoute: typeof TvRouteRoute
    }
    '/app/model-registry/': {
      id: '/app/model-registry/'
      path: '/'
      fullPath: '/app/model-registry/'
      preLoaderRoute: typeof AppModelRegistryIndexRouteImport
      parentRoute: typeof AppModelRegistryRouteRoute
    }
    '/app/model-registry/models': {
      id: '/app/model-registry/models'
      path: '/models'
      fullPath: '/app/model-registry/models'
      preLoaderRoute: typeof AppModelRegistryModelsRouteImport
      parentRoute: typeof AppModelRegistryRouteRoute
    }
    '/app/model-training/': {
      id: '/app/model-training/'
      path: '/'
      fullPath: '/app/model-training/'
      preLoaderRoute: typeof AppModelTrainingIndexRouteImport
      parentRoute: typeof AppModelTrainingRouteRoute
    }
    '/app/model-training/datasets': {
      id: '/app/model-training/datasets'
      path: '/datasets'
      fullPath: '/app/model-training/datasets'
      preLoaderRoute: typeof AppModelTrainingDatasetsRouteImport
      parentRoute: typeof AppModelTrainingRouteRoute
    }
    '/app/model-registry/models_/$modelId/evaluation': {
      id: '/app/model-registry/models_/$modelId/evaluation'
      path: '/models/$modelId/evaluation'
      fullPath: '/app/model-registry/models/$modelId/evaluation'
      preLoaderRoute: typeof AppModelRegistryModelsModelIdEvaluationRouteImport
      parentRoute: typeof AppModelRegistryRouteRoute
    }
    '/app/model-registry/models_/$modelId/experiment': {
      id: '/app/model-registry/models_/$modelId/experiment'
      path: '/models/$modelId/experiment'
      fullPath: '/app/model-registry/models/$modelId/experiment'
      preLoaderRoute: typeof AppModelRegistryModelsModelIdExperimentRouteImport
      parentRoute: typeof AppModelRegistryRouteRoute
    }
    '/app/model-training/datasets_/$datasetId/features': {
      id: '/app/model-training/datasets_/$datasetId/features'
      path: '/datasets/$datasetId/features'
      fullPath: '/app/model-training/datasets/$datasetId/features'
      preLoaderRoute: typeof AppModelTrainingDatasetsDatasetIdFeaturesRouteImport
      parentRoute: typeof AppModelTrainingRouteRoute
    }
    '/app/model-training/datasets_/$datasetId/preprocessing': {
      id: '/app/model-training/datasets_/$datasetId/preprocessing'
      path: '/datasets/$datasetId/preprocessing'
      fullPath: '/app/model-training/datasets/$datasetId/preprocessing'
      preLoaderRoute: typeof AppModelTrainingDatasetsDatasetIdPreprocessingRouteImport
      parentRoute: typeof AppModelTrainingRouteRoute
    }
    '/app/model-training/datasets_/$datasetId/preview': {
      id: '/app/model-training/datasets_/$datasetId/preview'
      path: '/datasets/$datasetId/preview'
      fullPath: '/app/model-training/datasets/$datasetId/preview'
      preLoaderRoute: typeof AppModelTrainingDatasetsDatasetIdPreviewRouteImport
      parentRoute: typeof AppModelTrainingRouteRoute
    }
    '/app/model-training/datasets_/$datasetId/train': {
      id: '/app/model-training/datasets_/$datasetId/train'
      path: '/datasets/$datasetId/train'
      fullPath: '/app/model-training/datasets/$datasetId/train'
      preLoaderRoute: typeof AppModelTrainingDatasetsDatasetIdTrainRouteImport
      parentRoute: typeof AppModelTrainingRouteRoute
    }
  }
}

interface AppModelRegistryRouteRouteChildren {
  AppModelRegistryModelsRoute: typeof AppModelRegistryModelsRoute
  AppModelRegistryIndexRoute: typeof AppModelRegistryIndexRoute
  AppModelRegistryModelsModelIdEvaluationRoute: typeof AppModelRegistryModelsModelIdEvaluationRoute
  AppModelRegistryModelsModelIdExperimentRoute: typeof AppModelRegistryModelsModelIdExperimentRoute
}

const AppModelRegistryRouteRouteChildren: AppModelRegistryRouteRouteChildren = {
  AppModelRegistryModelsRoute: AppModelRegistryModelsRoute,
  AppModelRegistryIndexRoute: AppModelRegistryIndexRoute,
  AppModelRegistryModelsModelIdEvaluationRoute:
    AppModelRegistryModelsModelIdEvaluationRoute,
  AppModelRegistryModelsModelIdExperimentRoute:
    AppModelRegistryModelsModelIdExperimentRoute,
}

const AppModelRegistryRouteRouteWithChildren =
  AppModelRegistryRouteRoute._addFileChildren(
    AppModelRegistryRouteRouteChildren,
  )

interface AppModelTrainingRouteRouteChildren {
  AppModelTrainingDatasetsRoute: typeof AppModelTrainingDatasetsRoute
  AppModelTrainingIndexRoute: typeof AppModelTrainingIndexRoute
  AppModelTrainingDatasetsDatasetIdFeaturesRoute: typeof AppModelTrainingDatasetsDatasetIdFeaturesRoute
  AppModelTrainingDatasetsDatasetIdPreprocessingRoute: typeof AppModelTrainingDatasetsDatasetIdPreprocessingRoute
  AppModelTrainingDatasetsDatasetIdPreviewRoute: typeof AppModelTrainingDatasetsDatasetIdPreviewRoute
  AppModelTrainingDatasetsDatasetIdTrainRoute: typeof AppModelTrainingDatasetsDatasetIdTrainRoute
}

const AppModelTrainingRouteRouteChildren: AppModelTrainingRouteRouteChildren = {
  AppModelTrainingDatasetsRoute: AppModelTrainingDatasetsRoute,
  AppModelTrainingIndexRoute: AppModelTrainingIndexRoute,
  AppModelTrainingDatasetsDatasetIdFeaturesRoute:
    AppModelTrainingDatasetsDatasetIdFeaturesRoute,
  AppModelTrainingDatasetsDatasetIdPreprocessingRoute:
    AppModelTrainingDatasetsDatasetIdPreprocessingRoute,
  AppModelTrainingDatasetsDatasetIdPreviewRoute:
    AppModelTrainingDatasetsDatasetIdPreviewRoute,
  AppModelTrainingDatasetsDatasetIdTrainRoute:
    AppModelTrainingDatasetsDatasetIdTrainRoute,
}

const AppModelTrainingRouteRouteWithChildren =
  AppModelTrainingRouteRoute._addFileChildren(
    AppModelTrainingRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppModelRegistryRouteRoute: typeof AppModelRegistryRouteRouteWithChildren
  AppModelTrainingRouteRoute: typeof AppModelTrainingRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppModelRegistryRouteRoute: AppModelRegistryRouteRouteWithChildren,
  AppModelTrainingRouteRoute: AppModelTrainingRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface KioskRouteRouteChildren {
  KioskIndexRoute: typeof KioskIndexRoute
}

const KioskRouteRouteChildren: KioskRouteRouteChildren = {
  KioskIndexRoute: KioskIndexRoute,
}

const KioskRouteRouteWithChildren = KioskRouteRoute._addFileChildren(
  KioskRouteRouteChildren,
)

interface TvRouteRouteChildren {
  TvIndexRoute: typeof TvIndexRoute
}

const TvRouteRouteChildren: TvRouteRouteChildren = {
  TvIndexRoute: TvIndexRoute,
}

const TvRouteRouteWithChildren =
  TvRouteRoute._addFileChildren(TvRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  KioskRouteRoute: KioskRouteRouteWithChildren,
  TvRouteRoute: TvRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
